<template>
  <echart :options="option" style="width:100%"></echart>
</template>

<script>
export default {
  name: 'stat-chart',
  props: ['data', 'fields'],
  computed: {
    option: function () {
      let chartOption = {
        tooltip: {},
        legend: {},
        xAxis: {type: 'category'},
        yAxis: {},
        series: [],
        dataset: {
          dimensions: ['stat_date'],
          source: this.data
        }
      }
      Object.keys(this.fields).map((field) => {
        if (chartOption.dataset.dimensions.indexOf(field) === -1) {
          chartOption.dataset.dimensions.push(field)
          chartOption.series.push({type: 'line'})
        }
      })
      chartOption.dataset.source.map((d) => {
        Object.keys(this.fields).map((field) => {
          if (Object.keys(d).indexOf(field) === -1) {
            d[field] = null
          }
        })
      })
      return chartOption
    }
  }
}
</script>



// WEBPACK FOOTER //
// StatChart.vue?153d517a